import { useEffect, useState } from "react";
import { HeartHandshake } from "lucide-react";
import { api, formatPrice } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

function Stat({ testid, value, label }) {
  return (
    <div className="rounded-xl bg-amber-50/70 px-4 py-3">
      <p data-testid={testid} className="font-serif text-2xl font-semibold text-bark">{value}</p>
      <p className="text-xs text-bark-soft">{label}</p>
    </div>
  );
}

export default function ChildThanks() {
  const { user } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/customer/referrals").then(({ data: d }) => setData(d)).catch(() => setData(null));
  }, []);

  if (!data || (!data.relatives_count && !user?.school_id)) return null;
  return (
    <div data-testid="child-thanks" className="rounded-2xl border border-amber-800/15 bg-white p-8 shadow-sm">
      <h2 className="flex items-center gap-2 font-serif text-xl font-semibold text-bark">
        <HeartHandshake size={20} className="text-amber-deep" /> Merci de l'enfant
      </h2>
      <p className="mt-1 text-sm text-bark-soft">
        Les commandes passées par vos proches grâce à votre lien de partage, pour la vente de l'école.
      </p>
      <div className="mt-5 grid gap-3 sm:grid-cols-3">
        <Stat testid="child-thanks-count" value={data.relatives_count} label={`proche${data.relatives_count > 1 ? "s" : ""} ${data.relatives_count > 1 ? "ont" : "a"} commandé`} />
        <Stat testid="child-thanks-total" value={formatPrice(data.total_cents)} label="récoltés pour l'école" />
        <Stat testid="child-thanks-points" value={`+${data.points}`} label="points gagnés grâce à eux" />
      </div>
      {data.relatives.length === 0 ? (
        <p data-testid="child-thanks-empty" className="mt-5 text-sm text-bark-soft">
          Partagez votre bon de commande : vous recevrez {data.account_percent} % des points de chaque proche qui commande avec son compte (les commandes sans compte ne rapportent pas de points).
        </p>
      ) : (
        <ul className="mt-5 divide-y divide-amber-900/10">
          {data.relatives.map((r, i) => (
            <li key={i} data-testid={`child-thanks-relative-${i}`} className="flex flex-wrap items-center justify-between gap-2 py-3 text-sm">
              <div>
                <p className="font-medium text-bark">{r.name}</p>
                <p className="text-xs text-stone-mute">{r.orders} commande{r.orders > 1 ? "s" : ""} · {formatPrice(r.total_cents)}{r.has_account ? " · a un compte" : ""}</p>
              </div>
              <span className="rounded-full bg-sage-light px-3 py-1 text-xs font-semibold text-sage">+{r.points} points</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
